import * as React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Opp3 from './Opp3';
import Service from './Service';

export default function App() {
  // const service= window.location.pathname.includes('/service') ? 'service' : null;
  return (
    <Router>
      <Routes>
        <Route path="/service" element={<Service />} />
        <Route path="/service/:env" element={<Service />} />
        <Route path="/" element={<Opp3 />} />
        <Route path="*" element={<Opp3 />} />
      </Routes>
    </Router>
  );
}
